import React from "react";
import Sugar from "sugar";
import { Link, useLocation } from "react-router-dom";

Sugar.extend();

function SearchResult({ searchResult, highlight }) {

  return (

    <section className={`search-result ${ highlight }`}>
      <div className="text">
        <div className="cell school">
          <div className="scorecard-school">{searchResult.school}</div>
          <div className="scorecard-degree">{searchResult.degree}</div>
          <div className="scorecard-major">{searchResult.major}</div>


        </div>
      </div>

      <div className="data">
        <div className="cell income">
          <div className="cell-content">
            <div className="header">You'll Make</div>
            <div className="value">${searchResult.income.format(0)}</div>
            <div className="descriptor">in first year</div>
          </div>
        </div>

        <div className="cell debt">
          <div className="cell-content">
            <div className="header">You'll Owe</div>
            <div className="value">${searchResult.debt.format(0)}</div>
            <div className="descriptor">in federal debt</div>
          </div>
        </div>
      </div>
    </section>

  );
}

SearchResult.defaultProps = {
  searchResult: {
    school: "Temple University",
    degree: "First Professional Degree",
    major: "Pharmacy, Pharmaceutical Sciences and Administration",
    debt: 136167,
    income: 117200
  }
};

export default SearchResult;
